module.exports = __webpack_public_path__ + "static/media/drumstick.77c9d563.svg";